export const transformation = [
  {
    before: "Cocinas cuando tienes ganas, sin un rumbo claro.",
    after: "Tienes un menú corto de productos elegidos para vender.",
  },
  {
    before: "Pones precios por intuición o copiando a otros.",
    after: "Calculas tu costo real y defines un precio con margen.",
  },
  {
    before: "Tu Instagram es personal y publicas sin plan.",
    after: "Tienes un perfil de emprendimiento y sabes qué publicar.",
  },
  {
    before: "Respondes WhatsApp improvisando cada mensaje.",
    after: "Usas mensajes listos para informar, cobrar y confirmar.",
  },
  {
    before: "Los pedidos se anotan en cualquier lado.",
    after: "Organizas producción, entregas y cobros en una sola planilla.",
  },
];
